export const validateEmail = (email: string) => {
  return String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    );
};
export const validateName = (name: string) => {
  return String(name)
    .toLowerCase()
    .match(/^[a-zA-Z ]{2,30}$/);
};

export const validatePassword = (password: string) => {
  return String(password).match(
    /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[-+_!@#$%^&*., ?])[A-Za-z\d\-+_!@#$%^&*., ?]{10,}$/,
  );
};
